define('w3c/conformance',["exports", "w3c/templates/conformance", "core/pubsubhub"], function (exports, _conformance, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;

  var _conformance2 = _interopRequireDefault(_conformance);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // Module w3c/conformance
  // Handle the conformance section properly.
  const name = exports.name = "w3c/conformance";

  function run(conf, doc, cb) {
    const $confo = $("#conformance");
    if ($confo.length) $confo.prepend((0, _conformance2.default)(conf).childNodes);
    // Added message for legacy compat with Aria specs
    // See https://github.com/w3c/respec/issues/793
    (0, _pubsubhub.pub)("end", "w3c/conformance");
    cb();
  }
});
//# sourceMappingURL=conformance.js.map;
